<template>
    <div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> --> 
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :per-page="perPage" :current-page="currentPage"  :items="staffItems" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                 <template #cell(img)="data">
                                    <img class="profile-image-md rounded-circle" :src="data.item.icon != '' ? data.item.icon : require('@/assets/image/icon/profile.png')"/>
                                </template>
                                        <template #cell(name)="data">
                                            <span>{{data.item.name}}</span>
                                        </template>
                                        <template #cell(enable)="data">
                                            {{data.item.enable == 0 ? '-' : convertTimestampToDateTime(data.item.enable)}}
                                        </template>
                                        <template #cell(deleteDate)="data">
                                            {{data.item.deleteDate == 0 ? '-' : convertTimestampToDateTime(data.item.deleteDate)}}
                                        </template>
                                        <template #cell(outlet)="data">
                                            <a class="link d-block text-primary" :title="$t('staff.header_view_edit')" @click="viewStaffOutlet(data.item.staffID, data.item.staffname, false)">
                                                <div class='icon-stack fs-xl'>
                                                    <i class="fal fa-store icon-stack-3x opacity-100 color-primary-500"></i>
                                                    <i class="fal fa-cog icon-stack-2x opacity-100 color-primary-300 ml-3" style="top: .5em;"></i>
                                                </div>
                                            </a>
                                        </template>
                                        <template #cell(action)="data">
                                            <a v-if="data.item.staffname != loginStaffname" class="link d-block text-primary" :title="$t('button_link.delete') + $t('subMenu.my_salon_staff')" @click="deleteStaff(data.item.staffID, data.item.staffname)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                            <a v-else class="d-block text-secondary" :title="$t('message.error.access_denied_staff')" disabled>
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'staffList',
    components:{
    },
    data(){
        return {
            isSpinnerShow: false,
            staffItems: [], permissionType: [], staffOutlet: [], staffExportData: [],
            deleteToggleModal: false, viewPermissionToggle: false, staffID: 0, staffname: "", loginStaffname: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "",
        }
    },
    computed:{
        fields(){
            var ret = []
            ret.push({ key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'})
            ret.push({ key: "img", label: "Icon", thClass: 'thead-themed align-middle', tdClass: 'align-middle'})
            ret.push({ key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true})
            ret.push({ key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'})
            ret.push({ key: "city", label: 'City', thClass: 'thead-themed align-middle', tdClass: 'align-middle',sortable: true})
            ret.push({ key: "enable", label: 'Enable Date', thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true})
            return ret
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "staffName"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "enable"
            ret["City"] = "city"
            ret["Create Date"] = "createDate"
            
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.keyStaffPermissionForm += 1
            this.setExportData(this.staffExportData)
        }
    },
    methods:{
        getTableHeaderStyle(id){
            var style = ""
            switch(id){
                case"action":
                    style = !this.deleteStaffPermission ? 'display: none' : ''
                    break
                case"outlet":
                    style = !this.staffOutletPermission ? 'display: none' : ''
                    break
            }
            return style
        },
        closeModal(isError){
            if(!isError){
                this.deleteToggleModal = false
                this.getStaffList()
                this.$refs.deleteModal.toggleModal = false
            }
            this.$parent.$parent.isModalShow = false
        },
        convertTimestampToDateTime(ts){
            return moment(ts*1000).format(this.$msg.CST.DATE_TIME_24)
        },
        setExportData(data){
            let header = this.$msg.REPORT.HEADER + "Staff"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),  " "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    staffName: data[i].name,
                    mobile: data[i].mobile,
                    city:data[i].city,
                    enable: data[i].enable == 0 ? '-' : this.convertTimestampToDateTime(data[i].enable),
                    createDate: data[i].createDate == 0 ? '-' : this.convertTimestampToDateTime(data[i].createDate),
                })
            }
        },
        getStaffList(){
            let $vm = this
            $vm.totalEntries = 0;
            $vm.isSpinnerShow = true;

            $vm.$axios({
                method: 'get', 
                url: $vm.$api.BEBUSINESS_STAFF,
                baseURL: "https://staff.tunai.io", 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                response.data.staffs.forEach(staff => {
                    response.data.cashiers.forEach( cashier =>{
                        if(staff.staffID === cashier.staffID)
                        Object.assign(staff,cashier)
                    });
                    response.data.masseurs.forEach( masseur =>{
                        if(staff.staffID === masseur.staffID)
                        Object.assign(staff,masseur)
                    });
                    response.data.outlets.forEach( outlet =>{
                        if(staff.outletID === outlet.outletID)
                        Object.assign(staff,outlet)
                    });
                });
                var result = response.data.staffs;
                console.log(result)
                var retData = setReturnData(result, response.data.count, $vm.page)
                $vm.staffItems = retData.result;
                $vm.totalPage = retData.totalPage;
                $vm.totalEntries = result.length;
                $vm.startPage = retData.startPage;
                $vm.endPage = result.length<$vm.perPage?result.length:$vm.perPage;
                $vm.isSpinnerShow = false;
                $vm.staffExportData = retData.result;
                $vm.setExportData(retData.result);
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        handlePagination(pg){
      if (pg != null) {
         this.page = pg;
        this.startPage =((pg-1)*100)+1;
        this.endPage = pg * 100;
        if(this.endPage>this.totalEntries){
          this.endPage = this.totalEntries;
        }
      }
        },
    },
    mounted(){
        let $vm = this;
        $vm.loginStaffname = $vm.$store.state.staffName
        $vm.getStaffList()

        var blockList = $vm.$store.state.blockList
        for(var i=0; i<blockList.length; i++){
            switch(blockList[i]){
                case"biz.staff.delete":
                    $vm.deleteStaffPermission = false;
                    break;
                case"biz.staff.outlet.*":
                    $vm.staffOutletPermission = false;
                    break;
                case"biz.staff.outlet.edit":
                    $vm.updateStaffOutletPermission = false;
                    break;
                case"biz.staff.permission.*":
                    $vm.staffPermission = false;
                    break;
            }
        }
    },
}
</script>
<style scoped>
.link{
    cursor: pointer;
}
.show{
    display: block;
}
.modal-body-lg, .modal-container{
    max-height: 65vh;
    min-height: 75vh;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>